import React from "react";
import "../../App.css";
import Cards from "../Cards";

function Pefour() {
  return (
    <>
      <div className="pe04">
        <img src="images/img-13.jpg" width="100%" height="auto" alt="" />
      </div>
      <Cards />
    </>
  );
}

export default Pefour;
